/* Files handed to the Print page from elsewhere (Home "Drag and drop", Library "Print"...).
 * In memory only: the Print page takes them once when it opens. */
let pending = [];
export function handToPrint(files) { pending = pending.concat([...files]); }
export function takeHandedFiles() { const f = pending; pending = []; return f; }
